<template>
  <section>
    <UnifiedFilterSearch
      :filterList="filterList"
      :itensFilter="getItemsFilter"
      :isCurrentTab="isCurrentTab"
      showInAnalysis
      showAutomaticProcessing
      bookmarkType="my_process_bookmarks"
      :tabPersistName="tabPersistName"
      @search-value="getSearchValue"
      @filters="getFilterList"
    />
    <div class="level">
      <div class="level-left has-text-left">
        <span class="has-text-weight-semibold register-row">
          {{ getPaginationDetails }}
          <b-switch
            v-if="hasAuthorizeDoePermission"
            v-model="filterList.can_return_doe"
            class="ml-10"
            role="switch"
          >
            {{ General.DOE_CAN_PROCESS_FILTER }}
          </b-switch>
        </span>
      </div>
      <div class="level-right">
        <div v-if="!isValidSelection" class="buttons">
          <b-tooltip
            v-if="canTramitSelection"
            :label="General.TEXTS.HAS_MIGRATE"
            :active="hasMigrateProcess"
            :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
            role="tooltip"
          >
            <b-button
              :type="isContrast ? 'is-white-dark' : 'is-primary'"
              class="mr-10"
              :disabled="hasMigrateProcess"
              role="button"
              @click="
                validateProcessMovimentation(
                  giveBackProcess,
                  'has_auto_draft_files'
                )
              "
            >
              <span>
                {{ General.GIVE_BACK }}
              </span>
            </b-button>
          </b-tooltip>
          <b-button
            v-if="
              hasPermission(userPermissions['ADD_RESPONSIBLE']) &&
                canTramitSelection
            "
            :type="isContrast ? 'is-white-dark' : 'is-primary'"
            role="button"
            @click="checkSecrecyOnAssignResponsible(null)"
          >
            <span>
              {{ General.CHANGE_RESPONSIBLE }}
            </span>
          </b-button>
          <b-button
            v-if="hasOriginProcessAvailable && canTramitSelection"
            :type="isContrast ? 'is-white-dark' : 'is-primary'"
            role="button"
            @click.stop="openModalReturnToOrigin()"
          >
            {{ General.TEXTS.PROCESSED_ORIGIN }}
          </b-button>
          <b-button
            :type="isContrast ? 'is-white-dark' : 'is-primary'"
            role="button"
            @click="checkIsConfidential(getProcessesListCompleteFile)"
          >
            <span>
              {{ General.EXPORT_PDF }}
            </span>
          </b-button>
        </div>
      </div>
    </div>
    <div v-if="observerPage" class="middle">
      <b-table
        class="custom-table-process-panel custom-5-columns"
        :data="myProcessList.count == 0 ? [] : myProcessList.list"
        :sortIcon="sortIcon"
        :sortIconSize="sortIconSize"
        :checkedRows.sync="selectedProcessUser"
        :aria-next-label="General.NEXT_PAGE"
        :aria-previous-label="General.PREVIOUS_PAGE"
        :aria-page-label="General.PAGE"
        :aria-current-label="General.CURRENT_PAGE"
        :defaultSort="sortOrder"
        backendSorting
        :checkable="!isMobile"
        hoverable
        :rowClass="
          row => getSignatureHistory(row).length && 'custom-notification'
        "
        role="table"
        :loading="isLoading"
        @sort="onSort"
      >
        <template>
          <b-table-column
            v-slot="props"
            field="default"
            :label="isMobile ? '' : 'hiddenText'"
            headerClass="icons hidden-text"
            cellClass="icons"
            :sortable="!isMobile"
          >
            <div class="process-icons">
              <span
                class="cursor-pointer"
                @click="setProcessFavorite(props.row)"
              >
                <b-tooltip
                  :label="props.row.favorite ? General.DISFAVOR : General.FAVOR"
                  :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                >
                  <b-icon
                    :type="
                      isContrast
                        ? 'is-white-dark'
                        : getFavoriteStarColor(props.row)
                    "
                    :icon="props.row.favorite ? 'star' : 'star-outline'"
                  />
                </b-tooltip>
              </span>
              <b-tooltip
                v-if="isConfidential(props.row)"
                :type="isContrast ? 'is-white' : 'is-blue-oil'"
                :position="isMobile ? 'is-left' : 'is-top'"
                :label="secrecyName(props.row)"
                role="tooltip"
              >
                <div class="circle-red">
                  <b-icon
                    type="is-white"
                    icon="lock"
                    customSize="mdi-inherit"
                  />
                </div>
              </b-tooltip>
              <b-tooltip
                v-if="subjectIcons[props.row.priority.type]"
                :label="props.row.priority.name"
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                :position="isMobile ? 'is-left' : 'is-top'"
              >
                <b-icon
                  :icon="subjectIcons[props.row.priority.type].icon"
                  :type="subjectIcons[props.row.priority.type].color"
                />
              </b-tooltip>
              <b-tooltip
                v-if="props.row.process_join_set.length"
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                :position="isMobile ? 'is-left' : 'is-top'"
              >
                <template v-slot:content>
                  <span class="has-text-weight-semibold">
                    {{ General.TEXTS.PROCESSES_APPENDERS }}
                  </span>
                  <div
                    v-for="(appendedProcess, index) in props.row
                      .process_join_set"
                    :key="index"
                  >
                    {{ applyMaskNUP(appendedProcess.nup) }}
                  </div>
                </template>
                <b-icon
                  :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                  icon="link-variant"
                />
              </b-tooltip>
              <b-tooltip
                v-if="props.row.status_doe"
                :label="showStatusDOE(props.row.status_doe)"
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                :position="isMobile ? 'is-left' : 'is-top'"
              >
                <b-icon
                  :type="colorStatusDOE(props.row.status_doe)"
                  icon="text-box-check"
                />
              </b-tooltip>
              <b-tooltip
                v-if="props.row.automatic_processing"
                :type="isContrast ? 'is-white' : 'is-blue-oil'"
                :position="isMobile ? 'is-left' : 'is-top'"
                :label="General.TEXTS.AUTOMATIC_PROCESSING_SECOND"
                role="tooltip"
              >
                <b-icon type="is-warning" icon="folder-arrow-left-right" />
              </b-tooltip>
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="nup"
            :label="General.NUP"
            :visible="isMobile"
          >
            <span class="has-text-color-8">
              {{ applyMaskNUP(props.row.nup) }}
            </span>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="subject_name"
            :label="General.SUBJECT"
            :sortable="!isMobile"
          >
            <div class="is-flex is-align-items-center">
              <div class="has-text-left">
                <routerLink
                  class="has-text-color-8 has-text-weight-semibold custom-hover"
                  role="link"
                  rel="search tag"
                  :to="`/app/processos/detalhamento/${props.row.id}`"
                >
                  {{ isMobile ? "" : `${applyMaskNUP(props.row.nup)} - ` }}
                  {{ props.row.subject_name }}
                </routerLink>

                <div v-if="!isMobile" class="has-text-color-8">
                  <span class="has-text-weight-semibold">
                    {{ General.ORIGIN_PROCEDURE }}:
                  </span>

                  <b-tooltip
                    multilined
                    :label="
                      props.row.from_capacity.replace(
                        /([\w-]+)\/([\w-]+)\/([\w-]+) (.+)/g,
                        '$1/$3 $4'
                      )
                    "
                    :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                    size="is-small"
                  >
                    <span>
                      {{
                        (props.row.from_capacity || "").replace(
                          /([\w-]+)\/([\w-]+)\/([\w-]+) (.+)/g,
                          "$1/$3"
                        )
                      }}
                    </span>
                  </b-tooltip>
                  <section v-if="props.row.observation">
                    <span class="has-text-weight-semibold">
                      {{ General.NOTES }}:
                    </span>
                    {{ props.row.observation }}
                  </section>
                </div>
                <div
                  v-if="props.row.bookmark.length && !isMobile"
                  class="bookmark-container"
                >
                  <b-tag
                    v-for="(tag, index) in props.row.bookmark.length <= 3
                      ? props.row.bookmark
                      : props.row.bookmark.slice(0, 2)"
                    :key="index"
                    rounded
                    :style="
                      `background-color: ${tag.backgroundColor}; color: ${tag.color}`
                    "
                  >
                    {{ tag.name }}
                  </b-tag>
                  <b-tag
                    v-if="props.row.bookmark.length > 3"
                    rounded
                    :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                    >E outros.
                  </b-tag>
                </div>
                <span
                  v-if="props.row.due_date && !isMobile"
                  class="due-date-label has-text-weight-semibold"
                >
                  {{ getDueDate(props.row.due_date) }}</span
                >
              </div>
              <div
                v-if="getSignatureHistory(props.row).length"
                class="spacing-mx-10"
              >
                <b-tooltip
                  :label="General.TEXTS.NEW_ACTIONS"
                  :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                  size="is-small"
                  class="is-flex is-align-items-center is-clickable"
                >
                  <div
                    class="custom-circle"
                    @click="openModalDetail(props.row)"
                  >
                    <span>
                      {{ getSignatureHistory(props.row).length }}
                    </span>
                  </div>
                </b-tooltip>
              </div>
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="last_tramited_date"
            :label="General.FROM"
            :visible="isMobile"
          >
            <div class="has-text-color-8">
              <b-tooltip
                multilined
                :label="
                  props.row.from_capacity.replace(
                    /([\w-]+)\/([\w-]+)\/([\w-]+) (.+)/g,
                    '$1/$3 $4'
                  )
                "
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                size="is-small"
              >
                <span>
                  {{
                    (props.row.from_capacity || "").replace(
                      /([\w-]+)\/([\w-]+)\/([\w-]+) (.+)/g,
                      "$1/$3"
                    )
                  }}
                </span>
              </b-tooltip>
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="user_responsible_date"
            :label="General.RECEIVED"
            :sortable="!isMobile"
            cellClass="custom-break"
          >
            <div>
              <div class="is-inline-mobile has-text-color-8">
                {{
                  new Date(props.row.user_responsible_date)
                    | dateFormat("DD/MM/YYYY")
                }}
              </div>
              <div class="is-inline-mobile has-text-color-8">
                <b-tooltip
                  v-if="!isMobile"
                  :label="General.LENGTH_OF_STAY"
                  :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                >
                  <b-icon
                    icon="clock-outline"
                    :type="isContrast ? 'is-white-dark' : 'is-blue-dark'"
                    size="is-small"
                  />
                </b-tooltip>
                {{ isMobile ? `-` : "" }}
                {{ getReceivedDifferenceDate(props.row.user_responsible_date) }}
              </div>
            </div>
          </b-table-column>

          <b-table-column v-slot="props" :visible="isMobile">
            <span
              v-if="props.row.due_date"
              class="due-date-label has-text-weight-semibold"
            >
              {{ getDueDate(props.row.due_date) }}
            </span>
            <div v-if="props.row.bookmark.length" class="bookmark-container">
              <b-tag
                v-for="(tag, index) in props.row.bookmark.length <= 3
                  ? props.row.bookmark
                  : props.row.bookmark.slice(0, 2)"
                :key="index"
                rounded
                :style="
                  `background-color: ${tag.backgroundColor}; color: ${tag.color}`
                "
              >
                {{ tag.name }}
              </b-tag>
              <b-tag
                v-if="props.row.bookmark.length > 3"
                rounded
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                >E outros.
              </b-tag>
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="user.last_name"
            :label="isMobile ? '' : General.ACTIONS"
            headerClass="actions-min-width"
            cellClass="actions-min-width"
          >
            <ActionsGrouper :actions="actionList(props.row)" customClass="" />
          </b-table-column>
        </template>
        <template slot="empty">
          <section class="section">
            <NoListMessage v-if="!isLoading" />
          </section>
        </template>

        <template slot="footer">
          <div class="table-footer">
            <div class="column is-12 number-page pl-0">
              <span
                class="has-text-black column is-12 pl-0 has-text-weight-normal"
              >
                <b-dropdown
                  v-model="perPage"
                  role="listbox"
                  :expanded="isMobile"
                  position="is-top-right"
                >
                  <template slot="trigger">
                    <b-button
                      class="custom-dropdown-button custom-ph-8"
                      role="button"
                    >
                      <label
                        >{{ perPage }}
                        {{ General.PER_PAGE.toLowerCase() }}</label
                      >

                      <b-icon class="spacing-mx-5" icon="chevron-down" />
                    </b-button>
                  </template>
                  <div class="has-text-color-8 spacing-p-5 has-text-centered">
                    {{ General.RECORDS_FOR_PAGE }}
                    <div class="list-page">
                      <b-dropdown-item
                        v-for="option in optionsPagination"
                        :key="option"
                        :value="option"
                        role="listitem"
                      >
                        <div>
                          {{ option }}
                        </div>
                      </b-dropdown-item>
                    </div>
                  </div>
                </b-dropdown>
              </span>
            </div>
            <div class="columns is-centered">
              <div class="column is-6">
                <b-pagination
                  :total="myProcessList.count"
                  :perPage="perPage"
                  :current.sync="currentPage"
                  rangeBefore="1"
                  rangeAfter="1"
                  order="is-centered"
                  class="process-panel-pagination"
                  rounded
                  :iconPrev="prevIcon"
                  :iconNext="nextIcon"
                  :aria-next-label="General.NEXT_PAGE"
                  :aria-previous-label="General.PREVIOUS_PAGE"
                  :aria-page-label="General.PAGE"
                  :aria-current-label="General.CURRENT_PAGE"
                  role="navigation"
                />
              </div>
            </div>
          </div>
        </template>
      </b-table>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import UnifiedFilterSearch from "@/components/UnifiedFilterSearch";
import NoListMessage from "@/components/NoListMessage";
import { General } from "@/utils/constants";
import { NUP, applyMask } from "@/utils/protocols";
import { getTimeDiff } from "@/utils/timeUtility";
import { showStatusDOE, colorStatusDOE } from "@/utils/processesUtility";
import ModalGiveBack from "@/views/App/ModalGiveBack";
import ModalAssignResponsible from "@/views/App/ModalAssignResponsible";
import ModalArchive from "@/views/App/ModalArchive";
import ModalWarning from "@/views/App/ModalWarning.vue";
import ModalNewsDetail from "@/views/App/ModalNewsDetail.vue";
import ModalSelectUser from "@/views/App/ModalSelectUser";
import ModalGiveBackOrigin from "@/views/App/ModalGiveBackOrigin.vue";
import { createFilterData } from "@/utils/filters";
import {
  PROCESS_PANEL_TABS as TABS,
  TAB_PERSIST_NAME as PERSIST_NAME,
  PROCESS_SUBJECT_ICONS as subjectIcons,
  USER_PERMISSIONS as userPermissions
} from "@/utils/enumerate";
import debounce from "lodash/debounce";
import { formatPagination } from "@/utils/transformers";
import { setPersistSort } from "@/plugins/indexDB";

export default {
  name: "ProcessesUser",
  components: {
    UnifiedFilterSearch,
    NoListMessage
  },
  data() {
    return {
      General,
      subjectIcons,
      userPermissions,
      showStatusDOE,
      colorStatusDOE,
      isLoading: true,
      defaultSortField: "user_responsible_date",
      sortField: JSON.stringify({ default: "desc" }),
      observerPage: true,
      defaultSortOrder: "desc",
      sortOrder: ["default", "desc"],
      selectedProcessUser: [],
      sortIcon: "menu-up",
      sortIconSize: "is-medium",
      currentPage: 1,
      prevIcon: "chevron-left",
      nextIcon: "chevron-right",
      perPage: 10,
      searchValue: "",
      filterList: {},
      orderByUrgent: undefined,
      ignoreOrderByDefault: false
    };
  },

  computed: {
    ...mapGetters({
      myProcessList: "getProcessListByUser",
      user: "getCurrentUser",
      hasPermission: "hasPermission",
      optionsPagination: "getItensPage",
      updateBySockets: "getUpdateBySockets",
      actualTab: "getCurrentTabProcessPanel",
      signatureRequests: "getSignatureRequests",
      isConfidentialCheck: "isConfidentialCheck",
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),

    hasMigrateProcess() {
      return this.selectedProcessUser.some(process => process.migrated);
    },

    getPaginationDetails() {
      return formatPagination(
        this.myProcessList,
        this.currentPage,
        this.perPage,
        "SIMPLIFIED"
      );
    },

    isValidSelection() {
      return this.selectedProcessUser.length < 2 ? true : false;
    },

    canTramitSelection() {
      return this.selectedProcessUser.every(process => process?.can_tramit);
    },

    hasOriginProcessAvailable() {
      return (
        this.hasPermission(userPermissions[`AUTHORIZE_DOE`]) ||
        this.hasPermission(userPermissions[`MANAGE_DOE`])
      );
    },

    hasPermissionAddConfidentialResponsible() {
      return this.hasPermission(
        userPermissions["ADD_CONFIDENTIAL_RESPONSIBLE"]
      );
    },

    hasAuthorizeDoePermission() {
      return this.hasPermission(userPermissions["AUTHORIZE_DOE"]);
    },

    getItemsFilter() {
      return [
        "PROCESS_ORIGIN",
        "PROCESS_ORIGIN_CAPACITY",
        "PROCESS_DATE",
        "PROCESS_DATE_CREATED",
        "PROCESS_CCS",
        "PROCESS_ANALYSIS",
        "PROCESS_BOOKMARKS",
        "PROCESS_STATUS_DOE",
        "PROCESS_ORDER_BY_URGENT"
      ];
    },

    filterData() {
      return createFilterData(this.filterList, "IN_ANALYSIS");
    },

    requestBaseData() {
      return {
        page: this.currentPage,
        search: this.searchValue,
        order_by: this.sortField,
        paginator_count: this.perPage,
        filters: this.filterData,
        ignore_order_by_default: this.ignoreOrderByDefault
      };
    },
    isCurrentTab() {
      return this.actualTab.value === TABS.IN_ANALYSIS.value;
    },

    tabPersistName() {
      return `${PERSIST_NAME.PROCESS_IN_ANALYSIS}_${this.user.id}`;
    },

    hasConfidentialSelected() {
      return this.selectedProcessUser.some(process =>
        this.isConfidential(process)
      );
    },

    hasPermissionViewConfidential() {
      return this.hasPermission(userPermissions["VIEW_CONFIDENTIAL_PROCESS"]);
    }
  },

  watch: {
    searchValue() {
      if (this.currentPage === 1) this.getAllUserData();
      else this.currentPage = 1;
    },

    currentPage() {
      this.getAllUserData();
    },

    perPage() {
      this.getAllUserData();
    },

    filterData() {
      if (this.currentPage === 1) this.getAllUserData();
      else this.currentPage = 1;
    },

    updateBySockets: {
      handler(value) {
        if (value === "update_analising") {
          if (this.isCurrentTab) this.getAllUserData();
          this.$store.commit("clearUpdateBySockets");
        }
      }
    },

    actualTab() {
      this.selectedProcessUser = [];
      if (this.isCurrentTab) {
        this.getAllUserData();
      }
    },

    myProcessList: {
      handler() {
        this.selectedProcessUser = [];
      }
    }
  },

  async beforeMount() {
    await this.getSortData();
    this.isCurrentTab && this.getAllUserData(!this.isCurrentTab);
  },

  methods: {
    ...mapActions({
      getSortPersist: "getPersistSortAction",
      myProcessListRequest: "myProcessListRequest",
      signatureHistory: "getSignatureHistoryRequest",
      favoriteProcess: "favoriteProcess",
      getCompleteProcessFileStream: "getCompleteProcessFileStream",
      getProcessesCompleteFile: "getProcessesCompleteFile",
      processCapacityList: "processCapacityListRequest",
      checkUserPermissionResponsible: "checkUserPermissionResponsible",
      readSignature: "readSignature",
      setFavoriteProcessRequest: "setFavoriteProcess",
      hasAutoDraftWritten: "hasAutoDraftWritten",
      requestCheckProcessDocumentJoint: "requestCheckProcessDocumentJoint",
      checkAccessProcessRequest: "checkAccessProcessRequest"
    }),
    ...mapMutations(["setCurrentProcess"]),

    getSearchValue(value) {
      this.searchValue = value;
    },

    getFilterList(filterList) {
      this.filterList = filterList;
    },

    showArchiveModal() {
      if (this.hasConfidentialSelected) {
        const hasConfidentialPermission = this.validateConfidentialView(
          General.TEXTS.CONFIDENTIAL_ARCHIVE_WARNING
        );
        if (!hasConfidentialPermission) return;
      }
      this.setCurrentProcess(this.selectedProcessUser[0]);
      this.$buefy.modal.open({
        parent: this,
        component: ModalArchive,
        props: {
          listProcess: this.selectedProcessUser,
          onClose: async () => {
            await this.getAllUserData();
            await this.processCapacityList({
              capacityId: this.user.capacity.capacity_id,
              page: 1,
              order_by: JSON.stringify({ last_tramited_date_es: "desc" })
            });
            await this.$store.dispatch("processArchiveRequest", {
              page: 1,
              order_by: JSON.stringify({ last_tramited_date_es: "desc" })
            });
            this.selectedProcessUser = [];
          }
        },
        onCancel: () => (this.selectedProcessUser = []),
        hasModalCard: true,
        trapFocus: true
      });
    },

    getDueDate(date) {
      const dueDate = new Date(date);
      const dateNow = new Date();
      const millisecondsPerDay = 86400 * 1000;

      const diff = dueDate - dateNow;
      const daysLeft = Math.ceil(diff / millisecondsPerDay);

      if (daysLeft >= 0) {
        return `Tempo restante ${General.FROM.toLowerCase()} ${daysLeft} dias`;
      } else return `Vencido há ${Math.abs(daysLeft)} dias`;
    },

    openWarningModal(message, confirmCallback) {
      this.$buefy.modal.open({
        parent: this,
        component: ModalWarning,
        props: {
          title: `${this.General.WARNING}!`,
          message,
          confirm: confirmCallback,
          buttons: [
            { label: General.YES, isConfirm: false, action: true },
            { label: General.NO, isConfirm: true, action: false }
          ]
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    async validateProcessMovimentation(
      callback,
      checkProp = "has_auto_draft_written",
      process = null,
      checkJoinFilled = false
    ) {
      if (process?.id) this.selectedProcessUser = [process];
      const callbackRecursive = () =>
        this.validateProcessMovimentation(callback, checkProp, process, false);

      if (checkJoinFilled) {
        const resultsHasJoin = await this.requestCheckProcessDocumentJoint(
          this.selectedProcessUser[0].id
        );

        if (resultsHasJoin?.length) {
          const userListText = resultsHasJoin
            .map(user => `${user.user_name} - ${user.organ}/${user.unit}`)
            .join(", ")
            .replace(/,([^,]*)$/, " e$1");

          let message =
            resultsHasJoin.length === 1
              ? this.General.MESSAGES.DOCUMENT_JOIN_FILLED_SINGULAR
              : this.General.MESSAGES.DOCUMENT_JOIN_FILLED_PLURAL;

          message = message.replace("(USERS)", userListText);

          this.openWarningModal(message, callbackRecursive);
        } else callbackRecursive();
      } else {
        const resultsAutoDraft = await Promise.all(
          this.selectedProcessUser.map(actual_process =>
            this.hasAutoDraftWritten({ processId: actual_process.id })
          )
        );
        const showModalAutoDraft = resultsAutoDraft.find(
          result => result[checkProp]
        );

        if (showModalAutoDraft)
          this.openWarningModal(
            `${this.General.MESSAGES.DISPATCH_FILLED}?`,
            callback
          );
        else callback();
      }
    },

    async checkSecrecyOnAssignResponsible(process) {
      if (process?.id) this.selectedProcessUser = [process];
      const hasConfidential = this.selectedProcessUser.some(
        this.isConfidential
      );
      if (hasConfidential) {
        const hasConfidentialPermission = this.validateConfidentialResponsible();
        if (!hasConfidentialPermission) return;

        const ids = this.selectedProcessUser.map(({ id }) => id);
        this.isLoading = true;
        const canChangeResponsible = await this.checkUserPermissionResponsible(
          ids
        );
        this.isLoading = false;
        if (!canChangeResponsible) return;
        const message =
          this.selectedProcessUser.length === 1
            ? this.General.MESSAGES.ALERT_PROCESS_SECRECY
            : this.General.MESSAGES.ALERT_PROCESS_SECRECY_MULTIPLES;
        this.$buefy.modal.open({
          parent: this,
          component: ModalWarning,
          props: {
            title: `${this.General.WARNING}!`,
            message,
            invertOutline: true,
            confirm: this.showAssignResponsibleModal,
            buttons: [
              { label: General.YES, isConfirm: true, action: true },
              { label: General.NO, isConfirm: false, action: false }
            ]
          },
          hasModalCard: true,
          trapFocus: true
        });
      } else {
        this.showAssignResponsibleModal();
      }
    },

    showAssignResponsibleModal() {
      this.$buefy.modal.open({
        parent: this,
        component: ModalAssignResponsible,
        props: {
          processList: this.selectedProcessUser,
          clearSelection: () => {
            this.selectedProcessUser = [];
          }
        },
        onCancel: () => (this.selectedProcessUser = []),
        hasModalCard: true,
        trapFocus: true
      });
    },

    addZero(number) {
      return (number < 10 ? "0" : "") + number;
    },

    getReceivedDifferenceDate(date) {
      return getTimeDiff(date);
    },

    getAllUserData: debounce(async function(only_count = false) {
      this.formatSort(...this.sortOrder);
      this.isLoading = true;
      if (this.observerPage) {
        await this.myProcessListRequest({
          ...this.requestBaseData,
          only_count
        });
        const processIdList = this.myProcessList?.list.map(
          process => process.id
        );
        if (processIdList) await this.signatureHistory(processIdList);
      }
      this.isLoading = false;
    }, 500),

    async getProcessesListCompleteFile() {
      const processList = [];
      this.selectedProcessUser.forEach(process => {
        processList.push({ process_id: process.id });
      });

      this.$buefy.modal.open({
        parent: this,
        component: ModalWarning,
        props: {
          title: this.General.WARNING,
          btnTypeYes: "is-warning",
          btnTypeNo: "is-primary",
          message: `${this.General.MESSAGES.ARE_YOU_SURE_YOU_WANT_EXPORT_PROCESSES}? ${this.General.MESSAGES.DISABLE_POPUP}`,
          confirm: async () => {
            await this.getProcessesCompleteFile(processList);
            this.snackToast.open({
              message: this.General.MESSAGES.PROCESSES_SUCCESSFULLY_EXPORTED,
              position: "is-top",
              type: "is-success",
              duration: 8000
            });
          }
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    async getSortData() {
      this.observerPage = false;
      this.sortOrder = await this.getSortPersist({
        sortField: this.sortField,
        tabPersistName: this.tabPersistName
      });
      this.observerPage = true;
    },

    formatSort(field, order) {
      if (field === "default") {
        this.sortField = JSON.stringify({ [this.defaultSortField]: order });
        this.ignoreOrderByDefault = false;
      } else {
        this.sortField = JSON.stringify({ [field]: order });
        this.ignoreOrderByDefault = true;
      }
    },

    onSort(field, order) {
      this.formatSort(field, order);
      setPersistSort({ name: this.tabPersistName, sort: { [field]: order } });
      this.sortOrder = [field, order];
      this.getAllUserData();
    },

    applyMaskNUP(value) {
      return applyMask(NUP, value);
    },

    async setProcessFavorite(process) {
      this.isLoading = true;
      await this.setFavoriteProcessRequest([
        {
          process_id: process.id,
          favorite: !process.favorite
        }
      ]);

      await this.getAllUserData();
    },

    giveBackProcess(process = null) {
      if (process?.id) this.selectedProcessUser = [process];

      this.$buefy.modal.open({
        parent: this,
        component: ModalGiveBack,
        props: {
          listProcess: this.selectedProcessUser
        },
        onCancel: () => (this.selectedProcessUser = []),
        canCancel: ["escape", "x", "outside"],
        hasModalCard: true,
        trapFocus: true
      });
    },

    async openModalGiveKnowledge(process) {
      this.isLoading = true;
      const canGiveKnowledge = await this.checkAccessProcessRequest({
        processId: process.id,
        flow: "give_knowledge_process"
      });
      this.isLoading = false;
      if (!canGiveKnowledge) {
        return;
      }
      this.$buefy.modal.open({
        parent: this,
        component: ModalSelectUser,
        props: { process, processGiveKnowledge: true },
        hasModalCard: true,
        trapFocus: true
      });
    },

    openModalDetail(process) {
      this.$buefy.modal.open({
        parent: this,
        component: ModalNewsDetail,
        props: {
          history: this.getSignatureHistory(process)
        },
        canCancel: ["escape", "x", "outside"],
        onCancel: () => this.getAllUserData(),
        hasModalCard: true,
        trapFocus: true
      });
      this.readSignature(process.id);
    },

    getSignatureHistory(process) {
      if (!process) return [];
      return (
        this.signatureRequests.filter(
          history => history.process_id === process.id
        ) || []
      );
    },

    secrecyName(process) {
      return process.secrecy.name || "";
    },

    isConfidential(process) {
      return this.isConfidentialCheck(process.secrecy.id);
    },

    validateConfidentialResponsible() {
      if (!this.hasPermissionAddConfidentialResponsible) {
        this.snackToast.open({
          message: this.General.TEXTS.CONFIDENTIAL_RESPONSIBLE_WARNING,
          position: "is-top",
          type: "is-warning",
          duration: 8000
        });
        return false;
      }
      return true;
    },

    validateConfidentialView(
      message = this.General.TEXTS.CONFIDENTIAL_VIEW_WARNING
    ) {
      if (!this.hasPermissionViewConfidential) {
        this.snackToast.open({
          message,
          position: "is-top",
          type: "is-warning",
          duration: 8000
        });
        return false;
      }
      return true;
    },

    checkIsConfidential(callback = () => null) {
      if (this.hasConfidentialSelected) {
        const hasConfidentialPermission = this.validateConfidentialView();
        if (!hasConfidentialPermission) return;

        this.$buefy.modal.open({
          parent: this,
          component: ModalWarning,
          props: {
            title: `${this.General.WARNING}!`,
            message: this.General.MESSAGES.ALERT_PROCESS_SECRECY,
            invertOutline: true,
            confirm: callback,
            buttons: [
              { label: General.YES, isConfirm: true, action: true },
              { label: General.NO, isConfirm: false, action: false }
            ]
          },
          hasModalCard: true,
          trapFocus: true
        });
      } else {
        callback();
      }
    },

    actionList(item) {
      return [
        {
          html: General.TEXTS.PDF_VIEW_HTML,
          position: this.isMobile ? "is-right" : "is-left",
          icon: "folder-search",
          callback: () => this.getCompleteProcessFileStream(item.id),
          dataCY: "view-process"
        },

        {
          label: this.General.ARCHIVE,
          icon: "archive-arrow-down",
          permission: this.hasPermission(userPermissions["ARCHIVE_PROCESS"]),
          validated: !item.process_join_id && item?.can_tramit,
          callback: () =>
            this.validateProcessMovimentation(
              this.showArchiveModal,
              undefined,
              item,
              true
            ),
          dataCY: "archive-process"
        },
        {
          label: this.General.GIVE_KNOWLEDGE_PROCESS,
          icon: "email-send",
          callback: () => this.openModalGiveKnowledge(item),
          dataCY: "give-knowledge-process"
        },
        {
          label: item.user_responsible_id
            ? this.General.CHANGE_RESPONSIBLE
            : this.General.ASSIGN_RESPONSIBLE,
          icon: "account-arrow-right",
          permission: this.hasPermission(userPermissions["ADD_RESPONSIBLE"]),
          validated: item?.can_tramit,
          callback: () => this.checkSecrecyOnAssignResponsible(item),
          dataCY: "change-responsible-process"
        },
        {
          label: this.General.GIVE_BACK,
          icon: "restore",
          validated:
            !item.process_join_id && !item.migrated && item?.can_tramit,
          callback: () =>
            this.validateProcessMovimentation(
              this.giveBackProcess,
              "has_auto_draft_files",
              item
            ),
          dataCY: "give-back-process"
        }
      ];
    },

    openModalReturnToOrigin(process = null) {
      if (process?.id) this.selectedProcessUser = [process];
      this.$buefy.modal.open({
        parent: this,
        component: ModalGiveBackOrigin,
        props: {
          listProcess: this.selectedProcessUser,
          callback: () => this.getAllUserData()
        },
        onCancel: () => (this.selectedProcessUser = []),
        hasModalCard: true,
        trapFocus: true
      });
    },

    getFavoriteStarColor(item) {
      return item?.favorite ? "is-yellow" : "is-blue-oil";
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables";

.due-date-label {
  font-size: 12px;
  color: $orange;
}
.tooltip-trigger a {
  padding-right: 8px;
}
.custom-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 22px;
  width: 22px;
  background-color: $color-5;
  color: $color-1;
}

.register-row {
  display: flex;
  @media screen and (max-width: $tablet) {
    flex-direction: column;
    justify-content: flex-start;
    gap: 5px;
    .switch {
      margin-left: 0 !important;
    }
  }
}
</style>
